import React,{useState} from 'react'

function TokenVisitorDetails({visitor}) {
    const [visitorDetails,setVisitorDetails] = useState(null)
    const getVisitorDetails = () => {
        setVisitorDetails(visitor);
    }

    const idTypeList = [
        {label:"NA", value:"0"},
        {label:"Driving L", value:"1"},
        {label:"Aadhar card", value:"2"},
        {label:"Pan card", value:"3"},
        {label:"Employee Id", value:"4"},
        {label:"Voter Id", value:"5"},
        {label:"Passport Id", value:"6"},
        {label:"UAN Number", value:"7"},
        {label:"Establishment Number", value:"8"},
        {label:"PPA Number", value:"9"},
        {label:"PF Account #", value:"10"},
    ]

    return (
        <>
            {!visitorDetails ?
                <button type="button" className="btn btn-outline-primary" onClick={getVisitorDetails} >{visitor.firstName===""?"--":visitor.firstName}</button>
                :
                <div className="row">
                    {visitorDetails.profileImage !== null &&
                        <div className="col-12">
                            <img src={visitorDetails.profileImage} class="img-thumbnail" alt="Visitor Photo" />
                        </div>
                    }
                    <div className="col-4">Name</div>
                    <div className="col-8">{visitorDetails.firstName===""?"--":visitorDetails.firstName}</div>
                    <div className="col-4">Phone</div>
                    <div className="col-8">{(visitorDetails.phone==="" || visitorDetails.phone===null)?"--":visitorDetails.phone}</div>
                    <div className="col-4">ID Details</div>
                    <div className="col-8">
                        {(visitorDetails.idType==="" || visitorDetails.idType===null)?
                            "--"
                        : 
                            <>{idTypeList[visitorDetails.idType].label} : {visitorDetails.idProof}</>
                        }
                    </div>
                </div>
            }
            <hr/>
        </>

    )
}

export default TokenVisitorDetails